import {useEffect, useState} from 'react'

import ConfigSelect from '../ConfigSelect.js'
import ShipperOption from './ShipperOption.js'

import {
  updateShipperID,
  labelShipperIDSelector,
  validShipperIDsSelector,
  onLabelPropertyValueChange,
  LABEL_PROPERTY_SHIPPER_ID,
  LABEL_PROPERTY_SHIPPER_IDS,
} from '../../../../data/labelInfos/index.js'
import {useSelector} from '../../../../store.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {SHIPPER_VENDORS} from '../../../../common/constants/ShipperNames.js'
import {EMPTY_DEPENDENT_PROPERTIES_FUNC} from '../useLabelProperty.js'

export const SHIPPER_LABEL_PROPERTIES = [
  LABEL_PROPERTY_SHIPPER_IDS,
  LABEL_PROPERTY_SHIPPER_ID,
]

export function shipperLabelPropertiesFunc() {
  return SHIPPER_LABEL_PROPERTIES
}

export default function ShipperSelect() {
  const {labelInfoID, shipperType} = useLabelConfigContext()
  const propertySpecs = ShipperSelect.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const [resetShipper, setResetShipper] = useState(false)
  const shipperID = useSelector((state) =>
    labelShipperIDSelector(state, {labelInfoID}),
  )
  const shipperIDs = useSelector((state) =>
    validShipperIDsSelector(state, {labelInfoID}),
  )

  useEffect(() => {
    if (!shipperIDs.includes(shipperID) && shipperIDs.length) {
      if (shipperID) {
        setResetShipper(true)
      }
      updateShipperID(labelInfoID, shipperIDs[0], () =>
        onLabelPropertyValueChange(labelInfoID, labelProperty),
      )
    }
  }, [shipperID, shipperIDs])

  return (
    <ConfigSelect
      value={shipperID}
      className="list__item--shipping-shipperIDs flex-grow"
      label="Carrier"
      required
      onChange={async (value) => {
        updateShipperID(labelInfoID, Number(value), () =>
          onLabelPropertyValueChange(labelInfoID, labelProperty),
        )

        setResetShipper(false)
      }}
      noEmptyOption
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      errorMessage={
        resetShipper ? 'Selected Carrier Archived, Resetting to Default' : null
      }
      overrideLabel="Override other selected carriers when preset is applied"
      overrideHelpTitle="Learn More"
      overrideHelpLink="https://support.ordoro.com/how-do-additive-vs-overwrite-presets-work-in-rate-shopping/"
    >
      {shipperIDs.map((id) => (
        <ShipperOption shipperID={id} key={id} />
      ))}
    </ConfigSelect>
  )
}

ShipperSelect.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc: shipperLabelPropertiesFunc,
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: () => SHIPPER_LABEL_PROPERTIES,
  },
]
